<template>
  <div class="content">
    <a-form :form="form" @submit="handleSubmit" v-if="detail != ''">
      <a-form-item v-bind="formItemLayout" label="公寓名称">
        <p>{{ detail.name }}</p>
      </a-form-item>
      <a-form-item v-bind="formItemLayout" label="地址">
        <p>
          {{
            detail.province == detail.city
              ? detail.city + detail.area + detail.address
              : detail.province + detail.city + detail.area + detail.address
          }}
        </p>
      </a-form-item>
      <a-form-item v-bind="formItemLayout" label="工单类型">
        <a-radio-group v-model="typeClean">
          <a-radio :value="2">双周</a-radio>
          <a-radio :value="3">深度</a-radio>
          <a-radio :value="1">开荒</a-radio>
          <a-radio :value="4">退租</a-radio>
        </a-radio-group>
      </a-form-item>
      <a-form-item v-bind="formItemLayout" label="计划服务日期">
        <a-date-picker v-model="plan_work_date" />
      </a-form-item>
      <a-form-item v-bind="formItemLayout" label="员工">
        <a-input @click="selectUser" v-model="userName" />
        <ul class="workerList" v-show="isShowWorkList">
          <li
            @click="selectedUser(element)"
            v-show="userList != ''"
            v-for="(element, k) in userList"
            :key="k"
          >
            <div class="info">
              <div>
                <h2>{{ element.name }}</h2>
                <p>{{ "&nbsp;&nbsp;&nbsp;" + element.phone }}</p>
                <p v-if="element.gender == 1">&nbsp;&nbsp;&nbsp;男</p>
                <p v-else-if="element.gender == 2">&nbsp;&nbsp;&nbsp;女</p>
                <p>
                  {{
                    element.distance == "10000000000km"
                      ? "&nbsp;&nbsp;&nbsp;未知"
                      : "&nbsp;&nbsp;&nbsp;" + element.distance
                  }}
                </p>
                <p v-show="element.times > 0">
                  {{ "&nbsp;&nbsp;&nbsp;保洁此公寓：" + element.times + "次" }}
                </p>
              </div>
              <div class="selectedBtn">
                <!-- <input
                  style="-webkit-appearance: button"
                  type="radio"
                  name="user"
                  :value="element.isChange"
                />
                <span>选择</span>-->
              </div>
            </div>
            <ul class="list">
              <li>
                <label>现居地：</label>
                <p>
                  {{
                    element.province == element.city
                      ? element.city + element.area + element.address
                      : element.province +
                        element.city +
                        element.area +
                        element.address
                  }}
                </p>
              </li>
              <li>
                <label>待完成工单：</label>
                <p v-show="element.no_finish_list == ''">无</p>
                <span v-show="element.no_finish_list.length > 0">【&nbsp;</span>
                <p
                  v-show="element.no_finish_list.length > 0"
                  v-for="(item, l) in element.no_finish_list"
                  :key="l"
                >
                  <span v-if="item.type == 1">{{
                    "开荒：" + item.count_num
                  }}</span>
                  <span v-else-if="item.type == 2">{{
                    "&nbsp;&nbsp;双周：" + item.count_num
                  }}</span>
                  <span v-else-if="item.type == 3">{{
                    "&nbsp;&nbsp;深度：" + item.count_num
                  }}</span>
                  <span v-else-if="item.type == 4">{{
                    "&nbsp;&nbsp;退租：" + item.count_num
                  }}</span>
                </p>
                <span v-show="element.no_finish_list.length > 0">&nbsp;】</span>
              </li>
            </ul>
            <!-- <div class="authentication">
              <p>实名认证</p>
              <p>安徽人</p>
            </div>-->
          </li>
          <li v-show="userList == ''">暂无</li>
        </ul>
      </a-form-item>
      <a-form-item v-bind="formItemLayout" label="备注">
        <a-textarea v-model="remark" />
      </a-form-item>
      <a-form-item
        v-if="typeClean == 4"
        v-bind="formItemLayout"
        label="退租类型"
      >
        <a-radio-group v-model="houseType">
          <a-radio :value="1">整套退租</a-radio>
          <a-radio :value="2">单间退租</a-radio>
          <a-radio :value="3">无房间退租</a-radio>
        </a-radio-group>
      </a-form-item>
      <a-form-item
        v-if="houseType == 2"
        v-bind="formItemLayout"
        label="房间编号"
      >
        <p v-show="roomList == ''">请先添加房源编号</p>
        <a-checkbox-group
          v-model="return_simple_number"
          v-show="roomList != ''"
        >
          <a-checkbox
            v-for="(element, k) in roomList"
            :key="k"
            :value="element"
            >{{ element }}</a-checkbox
          >
        </a-checkbox-group>
      </a-form-item>
      <a-form-item
        v-if="typeClean == 4 && (houseType == 2 || houseType == 1)"
        v-bind="formItemLayout"
        label="独卫数量"
      >
        <a-input-number :min="0" v-model="oneToiletNumber" />
      </a-form-item>
      <a-form-item v-if="typeClean == 4" v-bind="formItemLayout" label="其他">
        <a-radio-group v-model="return_include_public">
          <a-radio :value="1">包含公区</a-radio>
          <a-radio :value="2">不含公区</a-radio>
        </a-radio-group>
      </a-form-item>
      <a-form-item
        style="margin-top: 60px"
        :wrapper-col="{ span: 12, offset: 6 }"
      >
        <a-button style="margin-right: 30px" @click="handleReset"
          >重置</a-button
        >
        <a-button type="primary" html-type="submit">确认</a-button>
      </a-form-item>
    </a-form>
  </div>
</template>
<script>
import axios from "axios";
let moment = require("moment");
export default {
  data() {
    return {
      formItemLayout: {
        labelCol: { span: 6 },
        wrapperCol: { span: 14 }
      },
      form: this.$form.createForm(),
      isShowWorkList: false,
      typeClean: 2,
      houseType: 1,
      userID: "",
      detail: {},
      return_simple_number: [],
      roomList: [],
      plan_work_date: moment(),
      query_field: "",
      userList: [],
      userName: "",
      return_include_public: "",
      remark: "",
      oneToiletNumber: ""
    };
  },
  props: {
    sendDetail: {}
  },
  watch: {
    sendDetail() {
      this.handleReset();
      this.detail = this.sendDetail;
      this.isShowWorkList = false;
      this.getUser();
      // console.log(this.detail);
      if (
        this.detail.room_number != undefined &&
        this.detail.room_number != ""
      ) {
        this.roomList = this.detail.room_number.split(",");
      }
    },
    plan_work_date() {
      this.getUser();
    },
    userName() {
      this.getUser();
    }
  },
  mounted() {
    this.isShowWorkList = false;
    this.roomList = [];
    this.detail = this.sendDetail;
    this.getUser();
    if (this.detail.room_number != undefined && this.detail.room_number != "") {
      this.roomList = this.detail.room_number.split(",");
    }
  },
  methods: {
    selectUser() {
      this.isShowWorkList = true;
    },
    selectedUser(val) {
      this.isShowWorkList = false;
      this.userName = val.name;
      this.userID = val.user_id;
    },
    getUser() {
      let url =
        this.httpsBasic.url +
        this.httpsBasic.clean +
        "Work_order/guardListPosition";
      let date;
      this.plan_work_date == ""
        ? (date = "")
        : (date = moment(this.plan_work_date).format("YYYY-MM-DD"));
      let params = {
        token: window.localStorage.getItem("xnwfPcToken"),
        project_id: this.detail.project_id,
        longitude: this.detail.longitude,
        latitude: this.detail.latitude,
        house_id: this.detail.id,
        query_field: this.userName,
        plan_work_date: date
      };
      axios.post(url, params).then(res => {
        if (res.data.code == 200) {
          this.userList = res.data.data;
        }
      });
    },
    handleChange(e) {
      this.checkNick = e.target.checked;
    },
    handleReset() {
      this.houseType = "";
      this.typeClean = 2;
      this.plan_work_date = "";
      this.userName = "";
      this.userID = "";
      this.remark = "";
      this.return_simple_number = [];
      this.return_include_public = "";
    },
    handleSubmit(e) {
      e.preventDefault();
      let _this = this;
      this.$confirm({
        title: "提示",
        content: "派单后数据无法进行修改，是否确认无误进行操作",
        onOk() {
          _this.form.validateFields((err, val) => {
            if (!err) {
              let date;
              _this.plan_work_date == ""
                ? (date = "")
                : (date = moment(_this.plan_work_date).format("YYYY-MM-DD"));
              let oneToiletNumber;
              _this.oneToiletNumber == ""
                ? (oneToiletNumber = 0)
                : (oneToiletNumber = _this.oneToiletNumber);
              let url =
                _this.httpsBasic.url +
                _this.httpsBasic.clean +
                "Work_order/assignOrderByHouse";
              let params = {
                token: window.localStorage.getItem("xnwfPcToken"),
                house_id: _this.detail.id,
                type: _this.typeClean,
                plan_work_date: date,
                user_id: _this.userID,
                return_type: _this.houseType,
                return_simple_number: JSON.stringify(
                  _this.return_simple_number
                ),
                remark: _this.remark,
                return_include_public: _this.return_include_public,
                return_simple_wc: oneToiletNumber
              };
              if (_this.typeClean != 4) {
                delete params.return_type;
                delete params.return_simple_number;
                delete params.return_include_public;
                delete params.oneToiletNumber;
              }
              if (_this.houseType != 2) {
                delete params.return_simple_number;
              }
              axios
                .post(url, params)
                .then(res => {
                  if (res.data.code == 200) {
                    _this.$message.success("派单成功");
                    _this.handleReset();
                    _this.$emit("hideInSendOrder", false);
                  } else {
                    _this.$message.warning(res.data.message);
                  }
                })
                .catch(err => {
                  _this.$message.error("服务器出错了...");
                });
            }
          });
        },
        onCancel() {}
      });
    }
  }
};
</script>

<style lang="less" scoped>
.content {
  padding-top: 30px;
  .ant-form-item {
    margin-bottom: 10px;
  }
  .selectedBtn {
    input,
    span {
      display: inline-block;
      vertical-align: top;
      // line-height: 20px;
    }
    input {
      margin-top: 5px;
      margin-right: 2px;
    }
  }
  .info {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    > div {
      display: flex;
      flex-direction: row;
      align-content: center;
      h2 {
        font-weight: normal;
        margin-bottom: 0;
      }
    }
    > a {
      border: 1px solid #ccc;
      display: inline-block;
      height: 24px;
    }
  }
  .list {
    > li {
      display: flex;
      flex-direction: row;
    }
  }
  .authentication {
    p {
      display: inline-block;
      color: #999;
      margin-right: 30px;
    }
  }
  .workerList {
    background: #ffffcc;
    line-height: 24px;
    font-size: 12px;
    padding: 10px 10px 0;
    margin: 0;
    max-height: 300px;
    overflow-y: scroll;
    position: absolute;
    width: 100%;
    z-index: 1;
    > li {
      margin-bottom: 10px;
      padding-bottom: 10px;
      border-bottom: 1px dotted #ff6666;
      cursor: pointer;
    }
    > li:last-child {
      margin-bottom: 0;
      border-bottom: none;
    }
    label {
      font-size: 12px;
    }
  }
}
</style>
